import React from "react";
import {AutoSizer} from "react-virtualized";

import TableView from "../TableBase/components/TableView";
import GridView from "../TableBase/components/GridView";

export default ({displayProps, columns = [], list, actions, rowCount}) => {

  const {
    rowHeight,
    headerHeight,
    className
  } = displayProps;

  const stylingProps = {
    className,
    headerRowClass: `${className}__header-row`,
    headerColClass: `${className}__header-col`,
    rowClass: `${className}__row`,
    colClass: `${className}__col`,
    actionClass: `${className}__actions`,
    noDataClass: `${className}__no-data`
  }

  let constantWidth = 0;
  let stretchedCols = 0;

  const columnsTotalWidth = columns.reduce((acc, next) => {
    if (next.width) {
      constantWidth += next.width;
    } else if (next.minWidth) {
      stretchedCols += 1;
    }

    acc += (next.minWidth || next.width || 0);
    return acc;
  }, 0);

  return (
    <AutoSizer>
      {({width, height}) => {
        return width > columnsTotalWidth
          ? (
            <TableView
              width={width}
              height={height}

              constantWidth={constantWidth}
              stretchedCols={stretchedCols}

              headerHeight={headerHeight}
              rowHeight={rowHeight}

              {...stylingProps}

              columns={columns}
              actions={actions}

              list={list}
              rowCount={rowCount}
            />
          ) : (
            <GridView
              width={width}
              height={height}

              constantWidth={constantWidth}
              stretchedCols={stretchedCols}
              columnsTotalWidth={columnsTotalWidth}

              headerHeight={headerHeight}
              rowHeight={rowHeight}

              {...stylingProps}

              columns={columns}
              actions={actions}

              list={list}
              rowCount={rowCount}
            />
          )
      }}
    </AutoSizer>
  )
}
